// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1KA07","col":"styles_col__1WBUB"};